import { CaretLeftIcon, CaretRightIcon } from '../../../icon';
import { IconButton } from '../../icon-button';
import { WeekNavType } from '../types';

type NavigateProps = {
  onClick: (type: WeekNavType) => void;
  type: WeekNavType;
};

export const Navigate = ({ onClick, type }: NavigateProps) => (
  <IconButton
    label={type === 'previous' ? 'Previous Week' : 'Next Week'}
    onClick={() => onClick(type)}
    showLabelOnHover
  >
    {type === 'previous' ? <CaretLeftIcon /> : <CaretRightIcon />}
  </IconButton>
);
